import { getAPIFullUrl, getAxiosConfig, handleApiError } from './risapi'; // Use correct path: ../../../api/risapi
import { risapi } from './risapi'; // Use correct path: ../../../api/risapi

export const getRateTypes = async (filterParameters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/rate-types', filterParameters), getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

export const fetchRateType = async (rateTypeId, callback) => {
    try {
        const response = await risapi.get(`/api/rate-types/${rateTypeId}`, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

export const createRateType = async (newRateType, callback) => {
    try {
        // Simple data, JSON is fine
        const response = await risapi.post('/api/rate-types', newRateType, getAxiosConfig());
        if (response.status === 201) {
            callback(response.data);
        }
    } catch (error) {
        callback(error); // Let form handle validation
    }
};

export const updateRateType = async (editRateType, callback) => {
    try {
        // Simple data, JSON is fine
        const response = await risapi.put(`/api/rate-types/${editRateType.id}`, editRateType, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        callback(error); // Let form handle validation
    }
};

export const destroyRateType = async (deleteRateType, callback) => {
    try {
        const response = await risapi.delete(`/api/rate-types/${deleteRateType.id}`, getAxiosConfig());
        if (response.status === 204) {
            callback({ rate_type: deleteRateType }); // Success
        }
    } catch (error) {
        callback({ error }); // Let list page handle conflict/error
    }
};

export const destroyRateTypesMultiple = async (ids, callback) => {
    try {
        const sendData = { ids: ids, _method: 'delete' };
        const response = await risapi.post('/api/rate-types/delete/multiple', sendData, getAxiosConfig());
        if (response.status === 204) {
            callback({ rate_type: ids }); // Success
        }
    } catch (error) {
        callback({ error }); // Let list page handle conflict/error
    }
};